import { Heading, Text, FeatureCard } from '@bq/web-components';
import styles from './FeaturesSection.module.css';

const features = [
  {
    imageSrc: '/assets/images/ninja-final.png',
    imageAlt: 'A blue ninja posing with a sword as if ready to fight',
    title: 'Expert Know How',
    description:
      'BlueQueue builds industry-specific AI, combined with Artificial General Intelligence, including code generation and all things related to development, acts as your sherpa to ease your workload and to show you the path ahead.',
  },
  {
    imageSrc: '/assets/images/ninja-stealth.png',
    imageAlt: 'A blue ninja jumping with two swords to pounce.',
    title: 'Project Specific AI',
    description:
      'We provide project specific AI to give you a digital SME on your project. Rather than hunt and peck for answers, simply dialogue with BlueQueue to retrieve answers and resources delivered to your finger tips.',
  },
  {
    imageSrc: '/assets/images/ninja-agile.png',
    imageAlt: 'A blue ninja with a fist on the ground, ready to pounce.',
    title: 'Digital Agile',
    description:
      "Agile Development has been a valuable approach for teams, but there's been little digital innovation to streamline its tasks\u2014until now. BlueQueue offers digital Agile solutions and ceremonies, covering Kanban, Scrum, and SAFe.",
  },
  {
    imageSrc: '/assets/images/ninja-laptop.png',
    imageAlt: 'A blue ninja sitting with a laptop',
    title: 'Personalized Learning For Life',
    description:
      "We're here for your whole career, no matter where you work. BlueQueue will help you gain dev wisdom and learn various dev-ninja skills - earning recognition and perhaps certifications - all tailored to your individual path forward.",
  },
  {
    imageSrc: '/assets/images/ninja-standing.png',
    imageAlt: 'A blue ninja in a ready to act pose.',
    title: 'Automated Dev Analytics',
    description:
      "BlueQueue creates metrics that helps create predictability, a big part of Agile Development practices, so one can deliver on time and defect free. BlueQueue metrics help drive Digital Agile, your Personalized Learning and industry best practices across a variety of disciplines.",
  },
  {
    imageSrc: '/assets/images/ninja-praying-open.png',
    imageAlt: 'A blue ninja in a meditation pose',
    title: 'Easy Button Integrations',
    description:
      "We're big believers in automation. Expert dialogue with BlueQueue makes knowledge sharing and task and sub-task list creation simple to integrate with your preferred tools like your IDE, Atlassian, and office productivity apps. This way, you can concentrate on tech innovation while BlueQueue handles the project management.",
  },
];

export function FeaturesSection() {
  return (
    <section data-crd-id="r4.bq-features-section" data-crd-layer="r4" className={styles.section} id="plan">
      <div className={styles.container}>
        <div className={styles.header}>
          <Heading level={3} as={2} color="p500">
            A New Hope
          </Heading>
          <Heading level={2} as={1}>
            Join the Founding Circle
          </Heading>
          <Text size="r1">
            Be one of the first to shape what BlueQueue becomes. Founding
            Users get lifetime perks, direct input on the roadmap, and early
            access to every feature we ship&mdash;free while we&apos;re in
            Beta.
          </Text>
        </div>

        <div className={styles.grid}>
          {features.map((feat) => (
            <FeatureCard key={feat.title} {...feat} />
          ))}
        </div>
      </div>
    </section>
  );
}
